###

Provides an endpoint for accessing third-party connector status information.

Required request parameters:

- client_id

Optional request parameters:

- _page
- _pageitems
- _pagekey
- _pageorder
- connection_id
- status (see JOBS.STATUSES)

###

angular.module('rjmNg.common.api').factory 'Jobs', [
  "$resource"
  "$q"
  "sharedCaches"
  "serviceUrl"
  "JOBS"
  (
    $resource
    $q
    sharedCaches
    serviceUrl
    JOBS
  ) ->

    getJobsForClient = (clientId) ->

      paramDefaults =
        client_id: clientId
        _pagekey: "start_time"
        _pageorder: "desc"

      actions =
        get:
          method: "GET"
          withCredentials: true
          isArray: true
        create:
          method: 'POST'
          withCredentials: true

      URLS =
        thirdParty: serviceUrl("/jobs")
        database: serviceUrl("/clients/#{clientId}/connections/:connection_id/replicators/jobs")

      makeJobsResource = (source, params) ->
        params ?= if source is 'thirdParty' then paramDefaults else {}
        $resource URLS[source], params, actions

      getCacheKey = (source, requestParams) ->
        keys = Object.keys(requestParams)
        keys.sort()
        cacheKeyParams = keys.map (key) -> "#{encodeURIComponent(key)}=#{encodeURIComponent(requestParams[key])}"
          .join("&")

        return "#{source}?#{cacheKeyParams}"

      getJob = (source, requestParams, force=true) ->
        cache = sharedCaches.getSharedObject("jobs:#{clientId}", sharedCaches.OBJECT)
        cacheKey = getCacheKey(source, requestParams)

        if not force and cache[cacheKey]?
          return $q.when(cache[cacheKey])
        else
          deferred = $q.defer()

          jobsResource = makeJobsResource source

          jobsResource.get(requestParams).$promise.then (response) ->
            cache[cacheKey] = response
            deferred.resolve(response)
          , () ->
            delete cache[cacheKey]
            deferred.reject()

          return deferred.promise

      getLast: (connectionIds, source, commonRequestParams = {}, force=true) ->
        deferred = $q.defer()

        commonRequestParams._pageitems = 1

        requestPromises = connectionIds.map (id) ->
          requestParams = _.extend { connection_id: id }, commonRequestParams
          getJob(source, requestParams, force)

        $q.all(requestPromises).then (rawResponses) ->
          # Each rawResponse is an array (with 0 or 1 items)—extract the object or undefined
          responses = rawResponses.map (rawResponse) -> _.first rawResponse
          deferred.resolve _.object(connectionIds, responses)

        , deferred.reject

        return deferred.promise

      getLastSuccessful: (connectionIds, source, force=true) ->

        status = JOBS.STATUSES.SUCCESS
        if source is JOBS.SOURCES.DATABASE
          status = JOBS.STATUSES.COMPLETE

        @getLast connectionIds, source, { status: status }, force

      create: (connection, source) ->
        if source is 'thirdParty'
          postBody =
            client_id: clientId
            connection_id: connection.id
            connection_type: connection.type
            connection_name: connection.name
            start_date: connection.properties.start_date
            force_run: true

          jobsResource = makeJobsResource source, {}

          return jobsResource.create({}, postBody).$promise
        else
          return $q.reject('create not implemented for source: ' + source)

    # Return the same instance for all requests for the same client id. (So
    # caching still works.)
    instancesByClient = {}

    (clientId) ->
      if instancesByClient[clientId]?
        return instancesByClient[clientId]

      newInstance = getJobsForClient(clientId)
      instancesByClient[clientId] = newInstance

      return newInstance

]
